/**
 * Правила Telegram @username (публичный username):
 * - Только латинские буквы, цифры и подчёркивание
 * - 5–32 символа (без учёта @)
 * - Должен начинаться с буквы
 * - Не может заканчиваться на _
 * - Нельзя использовать __ подряд
 * - Регистр не важен для уникальности (здесь валидируем только формат)
 */

const USERNAME_BODY = /^[a-zA-Z](?!.*__)(?!.*_$)[a-zA-Z0-9_]{4,31}$/

// Обрезка пустот
export const stripTgUsernameWhitespace = (raw: string) => String(raw ?? '').replace(/\s/g, '').trim()

// Обрезка собачки
export const tgUsernameWithoutAt = (raw: string) => {
  const compact = stripTgUsernameWhitespace(raw)
  if (!compact) return ''
  return compact.startsWith('@') ? compact.slice(1) : compact
}

export const isValidTgUsername = (raw: string): boolean => {
  const body = tgUsernameWithoutAt(raw)
  if (!body) return false
  return USERNAME_BODY.test(body)
}

// Главный валидатор никнейма
export default function tgUsernameValidator(raw: string): true | string {
  const compact = stripTgUsernameWhitespace(raw)
  if (compact === '@') {
    return 'После символа @ введите username. Например: @data_heroes'
  }
  const body = tgUsernameWithoutAt(raw)
  if (!body) return 'Поле должно быть заполнено'
  if (!/^[a-zA-Z]/.test(body)) {
    return 'Username должен начинаться с латинской буквы. Например: @data_heroes'
  }
  if (!/^[a-zA-Z0-9_]+$/.test(body)) {
    return 'Допустимы только латинские буквы, цифры и символ «_» (без пробелов).'
  }
  if (body.includes('__')) {
    return 'Username не может содержать двух "_" подряд'
  }
  if (body.endsWith('_')) {
    return 'Username не может заканчиваться на «_». Уберите символ в конце.'
  }
  if (body.length < 5) {
    return 'Слишком короткий username'
  }
  if (body.length > 32) {
    return 'Максимум 32 символа в username (счёт без символа @).'
  }
  if (!USERNAME_BODY.test(body)) {
    return 'Некорректный формат Telegram username.'
  }
  return true
}
